export interface TestCase {
  id: number
  name: string
  version: number
  summary?: string
  preconditions?: string
  importance: number // 1=Low, 2=Medium, 3=High
  execution_type: number // 1=Manual, 2=Automated
  estimated_exec_duration?: number
  author_id: number
  author_name?: string
  creation_ts: string
  modification_ts: string
  active: boolean
  step_count?: number
  // NOTE: parent_id, project_id, suite_name, project_name REMOVED
  // TestCases have NO concept of hierarchy - use memberships instead
}

// Membership interfaces for many-to-many relationships
export interface TestCaseSuiteMembership {
  id: number
  suite_id: number
  testcase_id: number
  suite_name: string
  node_order: number
  added_at: string
}

export interface TestCaseProjectMembership {
  id: number
  project_id: number
  testcase_id: number
  project_name: string
  project_prefix?: string
  membership_type: 'direct' | 'via_suite'
  node_order: number
  added_at: string
}

export interface TestCaseMemberships {
  suites: TestCaseSuiteMembership[]
  projects_direct: TestCaseProjectMembership[]
  projects_via_suites: TestCaseProjectMembership[]
}

export interface TestStep {
  id: number
  testcase_id: number
  step_number: number
  actions: string
  expected_results: string
  execution_type: number
  active: boolean
}

export interface CreateTestCaseRequest {
  name: string
  author_id: number // User ID (required)
  summary?: string
  preconditions?: string
  importance?: number
  execution_type?: number
  estimated_exec_duration?: number
  // NOTE: parent_id REMOVED - use AddTestCaseToSuiteRequest after creation
}

// Request types for membership management
export interface AddTestCaseToSuiteRequest {
  testcase_id: number
  suite_id: number
  node_order?: number
}

export interface AddTestCaseToProjectRequest {
  testcase_id: number
  project_id: number
  node_order?: number
}

export interface UpdateTestCaseRequest {
  name?: string
  summary?: string
  preconditions?: string
  importance?: number
  execution_type?: number
  estimated_exec_duration?: number
  active?: boolean
  // NOTE: parent_id REMOVED - use membership endpoints to change suite assignments
}

export interface TestCasesResponse {
  testcases: TestCase[]
  total: number
  limit: number
  offset: number
  count: number
}

export interface CreateTestStepRequest {
  step_number: number
  actions: string
  expected_results: string
  execution_type?: number
}

export interface UpdateTestStepRequest {
  step_number?: number
  actions?: string
  expected_results?: string
  execution_type?: number
  active?: boolean
}

// Enums for better type safety
export enum TestImportance {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum ExecutionType {
  Manual = 1,
  Automated = 2,
}
